import { Button, Flex, Space } from 'antd';
import { FC } from 'react';
import { PlusCircle } from 'react-bootstrap-icons';
import { Link, useParams } from 'react-router-dom';

import { AppCardList, DomainPunycode } from '@/common/components';
import { AppRoutes, BaseQueryParams } from '@/common/interfaces';
import { CommonContainerTitle } from '@/common/layouts';

import {
  DomainConfigurationStatus,
  DomainConfigurationStatusTag,
  DomainDeployStatus,
  DomainHealthTag,
  DomainSchemeTag,
  DomainsMultiConfigurationModal,
  useGetAllDomainsQuery
} from '@/modules/Domains';

interface Props {
  currentPage: number;
  domainsListItems: BaseQueryParams<typeof useGetAllDomainsQuery>['data']['items'];
  domainsListTotalItems: BaseQueryParams<typeof useGetAllDomainsQuery>['data']['meta']['totalItems'];
  domainsListItemsPerPage: BaseQueryParams<typeof useGetAllDomainsQuery>['data']['meta']['itemsPerPage'];
  isLoading: boolean;
  handleChangePage: (page: number) => void;
}

export const DomainsListView: FC<Props> = ({
  currentPage,
  domainsListItems,
  domainsListTotalItems,
  domainsListItemsPerPage,
  isLoading,
  handleChangePage
}) => {
  const domainId = useParams()['*'];

  return (
    <>
      <CommonContainerTitle
        onlyExtra
        extra={
          <Space>
            <DomainsMultiConfigurationModal/>

            <Link to={ AppRoutes.DomainsCreate }>
              <Button icon={ <PlusCircle/> } type="primary">
                Створити домен
              </Button>
            </Link>
          </Space>
        }
      />

      <AppCardList
        headerTitle={ null }
        pagination={{
          current: currentPage,
          total: domainsListTotalItems,
          pageSize: domainsListItemsPerPage,
          disabled: isLoading,
          onChange: (page: number) => handleChangePage(page)
        }}
        selectedKey={ domainId }
        rowKey="id"
        titleKey="name"
        grid={{
          gutter: 16,
          xs: 1,
          sm: 1,
          md: 1,
          lg: 2,
          xl: 2,
          xxl: 3
        }}
        navigateTo={ (record) => ({ to: AppRoutes.DomainsById.replace(':domainId', record.id) }) }
        list={ domainsListItems }
        titleRender={ (title) => (
          <DomainPunycode domainName={ title }/>
        ) }
        content={ ({ configurationStatus, isDeployed, isHttps, healthStatus, deployStatus, isConfigured }) => (
          <Flex align="center" gap={ 4 }>
            {
              isConfigured &&
            (
              configurationStatus === DomainConfigurationStatus.Configured ||
              configurationStatus === DomainConfigurationStatus.Failed
            )
                ? (
                  <>
                    <DomainSchemeTag
                      isDeployed={ isDeployed }
                      isHttps={ isHttps }
                      deployStatus={ deployStatus }
                      simple
                      big
                      withSpinner
                    />
                    {
                      deployStatus === DomainDeployStatus.Deployed &&
                      <DomainHealthTag status={ healthStatus } simple big/>
                    }
                  </>
                )
                : configurationStatus !== DomainConfigurationStatus.NotConfigured &&
                <DomainConfigurationStatusTag
                  configurationStatus={ configurationStatus }
                  isConfigured={ isConfigured }
                />
            }
          </Flex>
        ) }
      />
    </>
  );
};
